import React, { useState } from 'react';
import { LuMailCheck } from 'react-icons/lu';
import EmptyState from '../EmptyState';
import { COPY } from '../../../contracts/copyMap';
import { auth } from '../../../firebase/Init';
import { doSendEmailVerification } from '../../../firebase/Auth';

// Verified-email gate (EMAIL_UNVERIFIED — not a content rejection). The Oracle
// only answers confirmed members, so the scan surface parks here until the
// caller follows the confirmation link.
//
//   I'VE CONFIRMED       reload the auth user; if verified, force a token
//                        refresh (the next callable must carry
//                        email_verified: true) and hand control back via
//                        onVerified. Otherwise show the not-yet note.
//   RESEND CONFIRMATION  re-dispatch the branded confirmation email.
const VerifyEmailRejection = ({ onVerified }) => {
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const handleConfirmed = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const user = auth.currentUser;
      if (user) {
        await user.reload();
        if (user.emailVerified) {
          // Refresh the ID token BEFORE re-running the pipeline, or the
          // backend gate still sees the stale unverified claim.
          await user.getIdToken(true);
          onVerified();
          return;
        }
      }
      setNote(COPY.VERIFY_EMAIL_NOT_YET_NOTE);
    } catch {
      // A reload/refresh failure is a network problem, not "still unverified" —
      // show the network note so the user retries instead of re-checking mail.
      setNote(COPY.REJECT_NETWORK_SUBTITLE);
    } finally {
      setBusy(false);
    }
  };

  const handleResend = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await doSendEmailVerification();
      setNote(COPY.VERIFY_EMAIL_RESENT_NOTE);
    } catch {
      setNote(COPY.REJECT_NETWORK_SUBTITLE);
    } finally {
      setBusy(false);
    }
  };

  return (
    <EmptyState
      headline={COPY.VERIFY_EMAIL_HEADLINE}
      subtitle={COPY.VERIFY_EMAIL_SUBTITLE}
      ctaLabel={COPY.VERIFY_EMAIL_CONFIRMED_CTA}
      onCta={handleConfirmed}
      secondaryCtaLabel={COPY.VERIFY_EMAIL_RESEND_CTA}
      onSecondaryCta={handleResend}
      note={note}
      icon={<LuMailCheck size={22} />}
    />
  );
};

export default VerifyEmailRejection;
